import { NgbTimeAdapter, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import { isInteger } from "./ngb-date-struct-adapter";
/**
 * @source https://github.com/ng-bootstrap/ng-bootstrap/blob/3992021de2ab793f2ea8811db694a8acae5acb56/src/timepicker/ngb-time-adapter.ts
 * @export
 * @class NgbTimeStructAdapter
 * @extends {NgbTimeAdapter<NgbTimeStruct>}
 */
export class NgbTimeStructAdapter extends NgbTimeAdapter<NgbTimeStruct> {
  /**
   * Converts a NgbTimeStruct value into NgbTimeStruct value
   */
  fromModel(time: NgbTimeStruct | null): NgbTimeStruct | null {
    return (time && isInteger(time.hour) && isInteger(time.minute)) ?
      { hour: time.hour, minute: time.minute, second: isInteger(time.second) ? time.second : <any>null } :
      null;
  }

  /**
   * Converts a NgbTimeStruct value into NgbTimeStruct value
   */
  toModel(time: NgbTimeStruct | null): NgbTimeStruct | null {
    return (time && isInteger(time.hour) && isInteger(time.minute)) ?
      { hour: time.hour, minute: time.minute, second: isInteger(time.second) ? time.second : <any>null } :
      null;
  }
}
